import React from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Image from 'react-bootstrap/Image';

import whoWeAreArrow from '../Images/Arrow_Who-we-are.png';
import otherArrow from '../Images/Small-arrow-for-other-3.png';

export default function About() {
    
     const getSunWestSuccessYears = () => {
    // Sun West founded in 08/12/1980 in PST
    const foundedDate = new Date("1980-08-12T00:00:00-07:00"); // PST offset is -07:00
    const todayDate = new Date();

    // Adjust todayDate to PST timezone
    const todayPST = new Date(
      todayDate.toLocaleString("en-US", { timeZone: "America/Los_Angeles" })
    );

    const yearDiff = todayPST.getFullYear() - foundedDate.getFullYear();
    const isDate2BeforeBirthday =
      todayPST.getMonth() < foundedDate.getMonth() ||
      (todayPST.getMonth() === foundedDate.getMonth() &&
        todayPST.getDate() < foundedDate.getDate());

    return isDate2BeforeBirthday ? yearDiff - 1 : yearDiff;
  };
    return (
        <>
            <div className="creatingd">
                <div>
                    <h1 className="creating" id="creating1">CREATING</h1>
                </div>
                <div>
                    <h1 className="creating">A BETTER FUTURE</h1>
                </div>
            </div>
            <div>
                <p className="creating1">You can WORK FROM HOME too!</p>
            </div>
            <Container fluid className="pt-4 aboutContent">
                <Row className="align-items-center pb-md-2 pb-lg-4">
                    <Col md={12} lg={3}>
                        <h2 className="aboutTitle">ABOUT US</h2>
                    </Col>
                    <Col xs={1} className="px-0 d-none d-sm-none d-md-none d-lg-block">
                        <Image src={whoWeAreArrow} fluid alt="Arrow" />
                    </Col>
                    <Col md={12} lg={8}>
                        <p className="aboutcontent">Sun West is a technology-driven mortgage company with over {getSunWestSuccessYears()} years of experience. As one of the fastest growing fintech companies, we provide exceptional service, technology, and product innovation.</p>
                        <p className="aboutcontent">Our team of brilliant engineers continually submit new patents and push the boundaries of the financial services industry through innovations in mobile apps, customer acquisition, retention algorithms, and A.I. - powered process automation. We need people like you to join our mission to lower the cost of financial services so we can reach new and underserved markets.</p>
                    </Col>
                </Row>

                <Row className="align-items-center pb-md-2 pb-lg-4">
                    <Col md={12} lg={3}>
                        <h2 className="aboutTitle">WHAT YOU WILL DO</h2>
                    </Col>
                    <Col xs={1} className="px-0 d-none d-sm-none d-md-none d-lg-block">
                        <Image src={otherArrow} fluid alt="Arrow" />
                    </Col>
                    <Col md={12} lg={8}>
                        <p className="aboutcontent">Work with a highly collaborative and creative team of talented engineers. Use creativity and innovation to solve problems in ways never before imagined. Create and build large-scale data-driven network architecture.</p>
                    </Col>
                </Row>

                <Row className="align-items-center pb-md-2 pb-lg-4">
                    <Col md={12} lg={3}>
                        <h2 className="aboutTitle">WHO ARE YOU</h2>
                    </Col>
                    <Col xs={1} className="px-0 d-none d-sm-none d-md-none d-lg-block">
                        <Image src={otherArrow} fluid alt="Arrow" />
                    </Col>
                    <Col md={12} lg={8}>
                        <p className="aboutcontent">You are a disciplined and highly qualified Software Engineer. We believe in using the right tool to get the job done. Prepare to work in a wide variety of technologies. Although most of our hard core development is in Java, our wealth of knowledge is embedded in C/C++, Java, Node JS, Oracle, and Amazon Lambda.</p>
                    </Col>
                </Row>
                <Row className="align-items-center pb-md-2 pb-lg-4">
                    <Col md={12} lg={3}>
                        <h2 className="aboutTitle">REQUIREMENTS</h2>
                    </Col>
                    <Col md={1} className="px-0 d-none d-sm-none d-md-none d-lg-block">
                        <Image src={otherArrow} fluid alt="Arrow" />
                    </Col>
                    <Col md={12} lg={8}>
                        <p id="scroll" className="aboutcontent">This position has no minimum education or experience requirements.  We are looking for <strong className="talent">talented engineers </strong>and <strong className="talent">architects</strong> who have an innate passion for creating beautiful and elegant systems.</p>
                        <p className="aboutcontent">If you fit this description, we'd like to meet with you to discuss a career with Sun West.</p>
                    </Col>
                </Row>
            </Container>
        </>
    )
}

